import type { NexoyaTeamFeatureFlag } from '../types';

type FeatureFlagLike = Pick<NexoyaTeamFeatureFlag, 'name' | 'status'> | null | undefined;

export const isFeatureFlagEnabled = (
  featureFlags: ReadonlyArray<FeatureFlagLike> | null | undefined,
  flagName: string,
): boolean => (featureFlags ?? []).some((ff) => ff?.name === flagName && ff?.status === true);
